<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style="transform: scale(1.2)">
    <path
        d="M9.15,8.23A2.25,2.25,0,0,0,6.88,6H2.29A2.25,2.25,0,0,0,0,8.21v4.53A2.26,2.26,0,0,0,2.26,15H6.87a2.27,2.27,0,0,0,2.28-2.23Z"
        style="fill-rule:evenodd" />
    <path
        d="M9.15,19.26A2.26,2.26,0,0,0,6.89,17H2.29A2.26,2.26,0,0,0,0,19.23v4.54A2.25,2.25,0,0,0,2.27,26h4.6a2.25,2.25,0,0,0,2.28-2.22h0Z"
        style="fill-rule:evenodd" />
    <path
        d="M20.58,8.23A2.25,2.25,0,0,0,18.31,6h-4.6a2.25,2.25,0,0,0-2.28,2.22h0v4.51A2.26,2.26,0,0,0,13.69,15h4.6a2.26,2.26,0,0,0,2.29-2.23h0Z"
        style="fill-rule:evenodd" />
    <path
        d="M20.58,19.26A2.26,2.26,0,0,0,18.32,17H13.71a2.27,2.27,0,0,0-2.28,2.23v4.51A2.25,2.25,0,0,0,13.67,26h4.62a2.25,2.25,0,0,0,2.29-2.21V19.26Z"
        style="fill-rule:evenodd" />
    <path
        d="M32,8.23A2.25,2.25,0,0,0,29.73,6H25.14a2.25,2.25,0,0,0-2.28,2.22h0v4.51A2.26,2.26,0,0,0,25.12,15h4.6A2.26,2.26,0,0,0,32,12.76V8.23Z"
        style="fill-rule:evenodd" />
    <path
        d="M32,19.26A2.26,2.26,0,0,0,29.74,17h-4.6a2.27,2.27,0,0,0-2.28,2.23v4.51A2.25,2.25,0,0,0,25.1,26h4.62A2.25,2.25,0,0,0,32,23.78h0Z"
        style="fill-rule:evenodd" />
    </svg>
